export type LinkType = 'cross-product' | 'internal' | 'external';

export const getLinkType = (href: string): LinkType => {
  if (/^\/business(?:\/|$|[?#])/.test(href)) {
    return 'cross-product';
  }
  if (href.startsWith('/') || href.startsWith('#')) {
    return 'internal';
  }
  return 'external';
};
